import axios from 'axios'
import { API_ENDPOINT } from '../constants'

/**
 * Get PPI configurations given the org and venue.
 * Documentation: https://docs.google.com/document/d/1S9Li3l4qSDDtl1i_nqOdGOQdJ2enURzeXBI44j8KcP4/edit#heading=h.t2s3fe6ntoho
 * @returns {Axios Response Object} - Returns the response from VNAPI PPI /configurations
 */
export const apiGetPpiConfigurations = () => {
  return axios.get(`${API_ENDPOINT}/ppi/configurations?venue=${process.env.REACT_APP_VENUE_UUID}`)
}

/**
 * Make a VNAPI PPI Proxy call to the API Functionality that you want. See VNAPI PPI Documentation for what is avialable per integration.
 * Documenation: https://docs.google.com/document/d/1S9Li3l4qSDDtl1i_nqOdGOQdJ2enURzeXBI44j8KcP4/edit#heading=h.t2s3fe6ntoho
 * @param {String} apiFunc - Which api functionality within PPI do you need to connect with? Examples: getAmenities, getDiscounts, reportOrder, etc.
 * @param {String} integration - What integration (FANMAKER, etc) do you want to call VNAPI ppi proxy with?
 * @param {Object} transaction - The transaction that you want applied to the apiFunc and integration.
 * @returns {Axios Response Object} - Returns the response from VNAPI PPI /proxy.
 */
export const apiPostPpiProxy = (apiFunc, integration, transaction) => {
  return axios.post(`${API_ENDPOINT}/ppi/proxy`, {
    apiFunc: apiFunc,
    integration: integration,
    transaction: transaction,
    venue: process.env.REACT_APP_VENUE_UUID
  })
}

/**
 * Make chained VNAPI PPI Proxy calls in order, synchronously. 
 * Documentation: https://docs.google.com/document/d/1S9Li3l4qSDDtl1i_nqOdGOQdJ2enURzeXBI44j8KcP4/edit#heading=h.t2s3fe6ntoho
 * @param {Array} apiFuncs - An ordered array of which apiFuncs within PPI that need to be hit. ['getAmenities', 'getDiscounts']
 * @param {String} integration - What integration (FANMAKER, etc) do you want to call VNAPI ppi proxy with?
 * @param {Object} transactions - An keyed object of transactions to supply to each service call. { 'getAmenities' : {...}, 'getDiscounts': {...} }
 * @returns {Array} Returns an array of responses, body, in order, of each API call.
 */
export const apiMakeChainServicesPpiProxyCalls = async (apiFuncs, integration, transactions) => {
  let responses = []
  for (let i = 0; i < apiFuncs.length; i++) {
    let response
    try {
      
      response = await apiPostPpiProxy(apiFuncs[i], integration, transactions[apiFuncs[i]])

      if (response.data) {
        response = response.data
      }
    } catch(e) {
      response = new Error(e.response.data.error)
    }
    responses.push(response)
  }
  return responses
}